import {createApp} from "vue";
import Notifications from "@kyvg/vue3-notification";
import ContactFormFlowModal from "./ContactFormFlowModal.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const CONTACT_FORM_FLOW_SELECTOR_TRIGGER = '.vf-contact-form-flow-button';

// There should be a better way to do this
let currentModal = null;
let currentWrapper = null;
let currentId = null;

const generateId = () => 'vf-ccf-flow-' + Math.random().toString(36).slice(2, 15)

const createWrapper = () => {
    currentWrapper = document.createElement('div');
    document.body.appendChild(currentWrapper);
    return currentWrapper;
}

const $ = window.jQuery;

const contactFormFlowFactory = {
    register: () => {
        // This is a delegated event handler, so it will work for any element that matches the selector now or in the future
        $(document.body)
            .on('click', CONTACT_FORM_FLOW_SELECTOR_TRIGGER, (e) => {
                $('.cffEmailError').hide();
                let emailInputValue = null;

                // Get the closest parent element with the class .cffEmailError in case we need to show
                let closest = $(e.target).parent().find('.cffEmailError');

                if(e.target.getAttribute('data-email-required') === 'true') {
                    const emailRegex = /^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*(\+[a-zA-Z0-9-]+)?@[a-z0-9-.]+(\.[a-zA-Z0-9]+)$/;
                    emailInputValue = $(e.target).parent().find('.email-input-hubspot').val();

                    if (emailInputValue === null || emailInputValue === '') {

                        closest.text('Email is required');
                        closest.show();
                        return false;
                    }
                    else if (!emailRegex.test(emailInputValue)) {
                        closest.text('Please write a valid email');
                        closest.show();
                        return false;
                    }
                }

                contactFormFlowFactory.open({
                    franchiseId: e.target.getAttribute('data-franchise-id'),
                    franchiseName: e.target.getAttribute('data-franchise-name'),
                    pageName: e.target.getAttribute('data-page-name'),
                    email: emailInputValue
                });

                // Kill the event, so we don't get a page reload if the original element is an anchor tag
                return false;
            });
    },
    open({ franchiseId, franchiseName, pageName, email }) {
        contactFormFlowFactory.close();

        // We want a unique ID for each modal just to be sure we don't have any conflicts or data mixing up between instances
        const flowId = currentId = generateId();

        currentModal = createApp(ContactFormFlowModal, {
            flowId,
            franchiseId,
            franchiseName,
            pageName,
            email
        });

        currentModal
            .use(Notifications)
            .component("v-select", vSelect)
            .mount(createWrapper());

        $('#' + flowId).modal('show');
    },
    close() {
        if (currentModal) {
            $('#' + currentId).modal('hide');
            currentModal.unmount();
        }

        if (currentWrapper && currentWrapper.parentNode) {
            document.body.removeChild(currentWrapper);
        }
    }
};

window.vf.contactFormFlow = contactFormFlowFactory;